import { IApiResponse } from "../../../@types/api-response.type";
import { IProfileType } from "../../../@types/profile.type";
import { IPosition } from "../../../@types/position.type";
import { Api } from "../ApiConfig";
import { ApiException } from "../ApiException";
import { ISeniority } from "../../../@types/seniority.type";
import { getErrorMessage } from "../../../utils/utils";

export const deleteProfile = async (id: string) => {
    try {
        const { data } = await Api.delete(`api/PositionCost/DeletePositionCost/${id}`)
        return data
    } catch (error) {
        throw new ApiException(getErrorMessage(error, 'Erro ao deletar CustomerResource'))
    }
    
}

export const addOrUpdateProfile = async (profile: IProfileType) => { 
    try {
        const { data } = await Api.post(`api/PositionCost/AddOrUpdatePositionCost`, profile)
        return data
    } catch (error) {
        throw new ApiException(getErrorMessage(error, 'Erro ao criar CustomerResource'))
    }
}

export const getAllProfiles = async () : Promise<IApiResponse<IProfileType[]> | ApiException>  => {
    try {
        const { data } = await Api.get<IApiResponse<IProfileType[]>>(`api/PositionCost/GetAllPositionCost`)
        return data
    } catch (error) {
        throw new ApiException(getErrorMessage(error, 'Erro ao buscar todos Perfils'))
    }
}

export const getAllPositions = async () : Promise<IPosition[]>  => {
  // try {
      const response  = await Api.get<IApiResponse<IPosition[]>>(`api/Position/GetAllPositions`);
      return response.data.result;
  // } catch (error: any) {
  //     console.log('Erro ao buscar todas as posições', error)
  // }
}

export const getAllSeniority = async () : Promise<ISeniority[]> => {
  // try {
      const response = await Api.get<IApiResponse<ISeniority[]>>(`api/Seniority/GetAllSeniority`)
      return response.data.result;
  // } catch (error: any) {
  //     return new ApiException(error.message || 'Erro ao buscar todas senioridades')
  // }
}

export const ProfileService = {
  deleteProfile,
  addOrUpdateProfile,
  getAllProfiles,
  getAllPositions,
  getAllSeniority
}
